module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "page-title background-light"
  }, [_vm._v(_vm._s(_vm.title))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da1d2216"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/breadcrumbs/breadcrumbs.vue
// module id = 324
// module chunks = 0